import { RowData } from './useUpdateTableRowModalProperties';

export function transformRow(rowData: RowData): RowData {
  return {
    rowId: rowData.rowId as string,
    data: {
      reference: {
        investmentId: rowData.data.investmentId,
        companyName: rowData.data.companyName,
        costsCurrent: rowData.data.costsCurrent,
        entryDate: rowData.data.entryDate,
        investmentCurrency: rowData.data.investmentCurrency,
        investmentName: rowData.data.investmentName,
        multipleToDate: rowData.data.multipleToDate,
      },
      projection: {
        exitDate: rowData.data.baseExitDate,
        exitMultiple: rowData.data.baseExitMultiple,
        futureSalesProceeds: rowData.data.baseProceedsToCome,
      },
      partialSales: rowData.data.basePartialSales ?? [],
      partialSalesSum: {
        salesDate: rowData.data.baseExitDate,
        costBaseReduction: 0,
        salesProceeds: 0,
      },
    },
  };
}

export function transformRowData(rows: RowData[] = []) {
  return rows.map(transformRow);
}

export function isInvestmentAssumptionForm(type: string | undefined) {
  return (
    type != null &&
    ['addonInvestmentRow', 'unrealizedInvestmentRow'].includes(type)
  );
}
